import { CinemaTheme } from '@watchlist/shared';

export type { CinemaTheme };

export interface CinemaThemeConfig {
  id: CinemaTheme;
  name: string;
  description: string;
}

export const CINEMA_THEMES: CinemaThemeConfig[] = [
  { id: 'none',       name: 'Off',         description: 'Clean dark background' },
  { id: 'celluloid',  name: 'Celluloid',   description: 'Film grain & vignette' },
  { id: 'lumiere',    name: 'Lumière',     description: 'Projector glow from above' },
];

export const GRAIN_SVG_URL =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='256' height='256'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E";
